import localforage from "localforage"

// creates instance of local database
export default function createLocalDatabase(dbName = 'main') {
    return localforage.createInstance({ name: dbName })
}